import { DurationLikeObject } from 'luxon';

import { IUserActivityGroupBy } from 'graphql/types';

export const getStepDuration = (
    groupBy: IUserActivityGroupBy
): DurationLikeObject => {
    switch (groupBy) {
        case IUserActivityGroupBy.QuarterHour:
            return { minutes: 15 };
        case IUserActivityGroupBy.Hour:
            return { hours: 1 };
        case IUserActivityGroupBy.Day:
            return { days: 1 };
        case IUserActivityGroupBy.Month:
            return { months: 1 };
        default:
            return { days: 1 };
    }
};
